// Returns the first value that isn't nullable
const getFirstNotNull = <T>(
	...params: (T | null | undefined)[]
): T | undefined => {
	return params.find((p) => p != null) as T | undefined;
};

export default getFirstNotNull;
